module.exports = __webpack_public_path__ + "/images/ico-primary-aportacion.a2b42c6.svg";